var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStress(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0001 24C25.1339 24 29.3702 28.197 29.9913 33.6211C30.0748 34.3524 29.5513 35 28.877 35H11.1231C10.4485 35 9.92494 34.3524 10.0089 33.6211C10.6299 28.197 14.8662 24 20.0001 24ZM20.0001 14C22.4853 14 24.5001 16.0147 24.5001 18.5C24.5001 20.9853 22.4853 23 20.0001 23C17.5148 23 15.5001 20.9853 15.5001 18.5C15.5001 16.0147 17.5148 14 20.0001 14Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5348 2.66826C29.8412 2.40561 30.2968 2.72106 30.1588 3.10029L27.7961 9.59176C27.722 9.79536 27.4969 9.90034 27.2933 9.82624L23.6361 8.49514C23.354 8.39247 23.287 8.02399 23.5149 7.82863L29.5348 2.66826Z",
    fill: "#92A0E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7914 14.4978C26.485 14.7604 26.0294 14.445 26.1674 14.0657L28.5301 7.57425C28.6042 7.37065 28.8293 7.26567 29.0329 7.33978L32.6901 8.67088C32.9722 8.77354 33.0391 9.14203 32.8112 9.33738L26.7914 14.4978Z",
    fill: "#606A96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7914 2.66826C10.485 2.40561 10.0294 2.72106 10.1674 3.10029L12.5301 9.59176C12.6042 9.79536 12.8293 9.90034 13.0329 9.82624L16.6901 8.49514C16.9722 8.39247 17.0391 8.02399 16.8112 7.82863L10.7914 2.66826Z",
    fill: "#92A0E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5348 14.4978C13.8412 14.7604 14.2968 14.445 14.1588 14.0657L11.7961 7.57425C11.722 7.37065 11.4969 7.26567 11.2933 7.33978L7.63608 8.67088C7.35402 8.77354 7.28704 9.14203 7.51494 9.33738L13.5348 14.4978Z",
    fill: "#606A96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStress);
export default __webpack_public_path__ + "static/media/ic_stress.2a101e39f6501c7554998ef29fdb86c2.svg";
export { ForwardRef as ReactComponent };